"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ListSignatureRequestTemplatesResponse", {
    enumerable: true,
    get: function() {
        return ListSignatureRequestTemplatesResponse;
    }
});
const _zod = require("zod");
const _responsehelpers = require("../helpers/response-helpers");
const SignatureRequestTemplateResponseItem = _zod.z.object({
    _id: _responsehelpers.ResponseObjectId,
    name: _zod.z.string(),
    lastUpdate: _zod.z.union([
        _zod.z.date(),
        _zod.z.string()
    ]).nullable(),
    actorCount: _zod.z.number().int()
});
const ListSignatureRequestTemplatesResponse = _zod.z.object({
    signatureRequestTemplates: _zod.z.array(SignatureRequestTemplateResponseItem),
    totalCount: _zod.z.number()
});
